import { Controller } from "@hotwired/stimulus"

// Bootstrap dropdown mit Checkboxen als Multi-Select, ausgewaehlte Eintraege
// werden als entfernbare Pills unterhalb angezeigt. Checkboxen bleiben die
// alleinige Quelle der Wahrheit (kein separater State) -- die Pills werden
// bei jeder Aenderung neu aus dem aktuell angehakten Zustand gerendert.
export default class extends Controller {
  static targets = ["checkbox", "pills"]

  connect() {
    this.render()
  }

  sync() {
    this.render()
    this.submit()
  }

  remove(event) {
    const checkbox = this.checkboxTargets.find((box) => box.value === event.currentTarget.dataset.value)
    if (!checkbox) return

    checkbox.checked = false
    this.render()
    this.submit()
  }

  render() {
    this.pillsTarget.innerHTML = ""

    this.checkboxTargets.filter((box) => box.checked).forEach((box) => {
      const label = this.element.querySelector(`label[for="${box.id}"]`)?.textContent?.trim() ?? box.value

      const pill = document.createElement("span")
      pill.className = "badge rounded-pill text-bg-primary d-inline-flex align-items-center gap-1"
      pill.textContent = label

      const remove = document.createElement("button")
      remove.type = "button"
      remove.className = "btn-close btn-close-white"
      remove.style.fontSize = "0.55em"
      remove.setAttribute("aria-label", `${label} entfernen`)
      remove.dataset.value = box.value
      remove.dataset.action = "multi-select-pills#remove"

      pill.appendChild(remove)
      this.pillsTarget.appendChild(pill)
    })
  }

  submit() {
    this.checkboxTargets[0]?.closest("form")?.requestSubmit()
  }
}
